import styled from 'styled-components';

export const TableEspecification = styled.div`
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    div {
      border: 2px solid #e2e2e2;
      & + div {
        border-top: 0px;
      }
      &:first-child{
        border-radius: 15px 15px 0px 0px;
      }
      &:last-child{
        border-radius: 0px 0px 15px 15px;
      }
      display: flex;
      justify-content: center;

      h4 { 
        width: 100%;
        font-size: 1.37rem;
        white-space: wrap;
        border-right: 2px solid #e2e2e2;
      }
      span {
        font-size: 1.25rem;
        padding: 10px 2%;
        text-align: center;
        width:70%;
      }
    }
`
